module.exports = __webpack_public_path__ + "static/media/bg.23afba55.png";